import React from "react";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { Container } from "./styles";
import { FormattedMessage } from "react-intl";
import Button from "../../../../newUXPages/InformaAcademy/components/Button";

export default function EmptyFilter({ resetFilters }) {
  return (
    <Container>
      <AiOutlineExclamationCircle size={48} />
      <p>
        <FormattedMessage id="homepage_empty_filter" />
      </p>
      <Button label={"homepage_reset_filters"} onClick={resetFilters} />
    </Container>
  );
}
